import { __assign, __decorate, __extends } from "tslib";
import React from 'react';
import Toast from './Toast';
import { observer } from 'mobx-react';
var ToastContainer = /** @class */ (function (_super) {
    __extends(ToastContainer, _super);
    function ToastContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToastContainer.prototype.render = function () {
        return (React.createElement("div", { className: "toast-container" }, this.props.notificationStore.notifications.map(function (notification) { return (React.createElement(Toast, __assign({ key: notification.identifier }, notification.options, { refreshValue: notification.refreshValue }), notification.body)); })));
    };
    ToastContainer = __decorate([
        observer
    ], ToastContainer);
    return ToastContainer;
}(React.Component));
export default ToastContainer;
